import { useRef, useEffect, ReactNode } from 'react';
import ReactDOM from 'react-dom';

const ModalPortal = ({ children }: { children: ReactNode }) => {
  const portalElementRef = useRef(document.createElement('div'));

  useEffect(() => {
    const currentPortalElement = portalElementRef.current;

    document.body.appendChild(currentPortalElement);

    const modalCount = getModalCount(true);

    document.body.setAttribute('data-modal-open', modalCount.toString());

    if (modalCount === 1) {
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.body.removeChild(currentPortalElement);

      const modalCount = getModalCount(false);

      document.body.setAttribute('data-modal-open', modalCount.toString());

      if (modalCount === 0) {
        document.body.removeAttribute('data-modal-open');
        document.body.style.overflow = '';
      }
    };
  }, []);

  const getModalCount = (increment: boolean) => {
    const currentCount = Number(getDataModalOpenAttr('data-modal-open')) || 0;
    const newCount = increment ? currentCount + 1 : currentCount - 1;

    document.body.setAttribute('data-modal-open', newCount.toString());

    return newCount;
  };

  return ReactDOM.createPortal(children, portalElementRef.current);
};

export default ModalPortal;
export const getDataModalOpenAttr = (attr: string) => document.body.getAttribute(attr);
